import { render, staticRenderFns } from "./ProjectTaskTemplateViewForm.vue?vue&type=template&id=4d15a704"
import script from "./ProjectTaskTemplateViewForm.vue?vue&type=script&lang=js"
export * from "./ProjectTaskTemplateViewForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports